import { CommonModule, Location, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { TranslocoService } from '@jsverse/transloco';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ApprezzoCommonModule } from '../../../../apprezzoo-common.module';
import { AuthService } from '../../../../services/auth/auth.service';
import { BannerService } from '../../../../services/banner/banner.service';
import { FooterComponent } from '../../../shared/footer/footer.component';
import { HeaderComponent } from '../../../shared/header/header.component';
import { MobileNavComponent } from '../../../shared/mobile-nav/mobile-nav.component';
import { BannerComponent } from '../../shared/banner/banner.component';
import { BreadcrumbComponent } from '../../shared/breadcrumb/breadcrumb.component';
import { FabComponent } from '../../shared/fab/fab.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    RouterModule,
    DialogModule,
    ApprezzoCommonModule,
    ConfirmDialogModule,
    CommonModule,
    ReactiveFormsModule,
    ConfirmPopupModule,
    BannerComponent,
    NgIf,
    HeaderComponent,
    FooterComponent,
    MobileNavComponent,
    FabComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  bannerVisible: boolean = false;
  bannerContent: string | null = null;
  profileRedirectDialogVisible = false;
  private readonly destroy$ = new Subject<void>();
  messageDialog: any = {
    header: '',
    message: '',
    description: '',
    button: '',
  };
  isMobile = false;

  constructor(
    private readonly bannerService: BannerService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly translocoService: TranslocoService,
    private readonly router: Router,
    private readonly location: Location,
  ) {
    router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        const currentRoute =
          this.activatedRoute.firstChild?.snapshot.data ?? this.location.getState() ?? ({} as any);
        const showBanner = currentRoute['showBanner'] ?? false;
        const bannerContent = currentRoute['bannerContent'] ?? null;
        this.bannerService.updateBanner(showBanner, bannerContent);
      });
  }

  ngOnInit(): void {
    this.loadTranslations();
    const platform = Capacitor.getPlatform();

    if (platform !== 'web') {
      this.isMobile = true;
    }
    this.bannerService.bannerState$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.bannerVisible = state.visible;
      this.bannerContent = state.content;
    });
    this.authService.dialogVisible$.subscribe((visible) => {
      this.profileRedirectDialogVisible = visible;
    });
    this.authService.startUserRefreshCron();
  }
  redirectToUserProfile() {
    this.authService.hideDialog();

    this.translocoService.selectTranslate(`routes.profilo-utente`).subscribe((translation) => {
      const translatedPath = `dashboard/${translation}`;
      if (translation) {
        this.router.navigate([translatedPath]);
      }
    });
  }

  private loadTranslations(): void {
    this.translocoService
      .selectTranslateObject('message.complete-profile')
      .pipe(takeUntil(this.destroy$))
      .subscribe((translations) => {
        this.messageDialog.header = translations.header;
        this.messageDialog.message = translations.message;
        this.messageDialog.description = translations.description;
        this.messageDialog.button = translations.button;
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
